module.exports = __webpack_public_path__ + "static/media/12.a23f9b53.jpg";